import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicForgotEmail = React.lazy(() => import(/* webpackChunkName: "dynamic-forgot-email" */ './DynamicForgotEmail'));

componentService.registerPageComponents({ 'dynamic-forgot-email': DynamicForgotEmail });
